enum OrganizationType {
  Customer = 1,
  Reseller = 2,
  Keesing = 3,
}

export { OrganizationType };
